<template>
    <section>
        <router-view />

        <ui-modal-units-data />
    </section>
</template>

<script>
	import uiModalUnitsData from '@/components/ui-facilita/products/units/modal-units-data'

	export default{
		name: 'ui-products',

        components: {
            uiModalUnitsData
        },
	}
</script>

<style lang="stylus" scoped>
	section
		width: 100%
		height: 100%
</style>